import React, { useEffect } from 'react';
import { useDispatch} from 'react-redux';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {setIsShowSaveModal, setRefreshPreferencesAndSubscription} from "../../redux/profile/slice";

export const SavedModal = ({modalName,handleCloseModal, dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        return()=>{
            dispatch(setIsShowSaveModal(false))
            dispatch(setRefreshPreferencesAndSubscription(true))
        };
    }, []);

    useEffect(() => {
        const overlay = "Saved Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const handleClose = ()=>{
        dispatch(setIsShowSaveModal(false))
        handleCloseModal();
    }

    const getFooter = () => {
        return <ReactModalFooter
            primaryButtonText={"Close"}
            handleOnClick={handleClose}
            primaryButtonId={ANALYTICS_IDS.SavedModalCloseBtn}
        />
    };

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>

                <ReactModalContent>
                    <ReactModalHeader modalTitle="Saved!"/>
                    Your preferences and subscriptions have been updated.
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

